import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["options", "label", "value", "onChange", "className", "defaultValue"],
  _excluded2 = ["code"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect } from "react";
import { ELSNativeSelect } from "components/common/elsevier/Select/NativeSelect";
import { ELSNativeSelectOption } from "components/common/elsevier/Select/NativeSelectOption";
import Styles from "./Styles.module.scss";
function Select(_ref) {
  var pureOptions = _ref.options,
    label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className,
    defaultValue = _ref.defaultValue,
    props = _objectWithoutProperties(_ref, _excluded);
  var options = pureOptions.map(function (_ref2) {
    var code = _ref2.code,
      option = _objectWithoutProperties(_ref2, _excluded2);
    return _objectSpread(_objectSpread({}, option), {}, {
      value: code
    });
  });
  useEffect(function () {
    if (!value && defaultValue) onChange(defaultValue);
  }, []);
  var handleChange = useCallback(function (_ref3) {
    var newValue = _ref3.target.value;
    onChange(newValue);
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(Styles.select, " ").concat(className !== null && className !== void 0 ? className : "")
  }, /*#__PURE__*/React.createElement("span", {
    "data-cy": "search-within-label"
  }, label), /*#__PURE__*/React.createElement(ELSNativeSelect, {
    inputProps: props,
    as: "label",
    value: value,
    onChange: handleChange
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(ELSNativeSelectOption, {
      key: "".concat(option.value, "-").concat(option.label),
      value: option.value,
      "data-cy": "search-within-input"
    }, option.label);
  })));
}
Select.defaultProps = {
  label: ""
};
export default Select;